"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeacherAndParentLogin = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./styles.scss");
var _loginForm = require("../../schoolUiComponents/loginForm");
var _state = require("./../../authSignin/state");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var TeacherAndParentLogin = exports.TeacherAndParentLogin = function TeacherAndParentLogin(_ref) {
  var _ref$isTeacher = _ref.isTeacher,
    isTeacher = _ref$isTeacher === void 0 ? false : _ref$isTeacher,
    _ref$isParent = _ref.isParent,
    isParent = _ref$isParent === void 0 ? false : _ref$isParent;
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    sendEvent = _useAuthSigninState.sendEvent;
  var teacherParentTabSwitchEvent = function teacherParentTabSwitchEvent(page) {
    trackPageViewOnGa('login-popup');
    sendEvent("Login as ".concat(page));
    window.location.hash = page;
  };
  (0, _react.useEffect)(function () {
    localStorage.setItem("showClassroomActivitySelection", "1");
    var script = document.createElement('script');
    script.src = "https://cdn.pagesense.io/js/splashlearn/0763448b82a04ecabdf1f12f3b7a2db1.js";
    document.head.appendChild(script);
    return function () {
      document.head.removeChild(script);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "teacher-and-parent-login ".concat(isTeacher ? 'teacher' : 'parent'),
    "data-test-id": "parent-and-teacher-login",
    "data-sentry-component": "TeacherAndParentLogin",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "login-back dark",
    onClick: function onClick() {
      return window.location.hash = "";
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "iconcust-iconBackBtn"
  })), /*#__PURE__*/_react["default"].createElement("h4", null, "Log In as"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab-view"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab ".concat(isTeacher ? "active" : ""),
    onClick: function onClick() {
      teacherParentTabSwitchEvent("#teacher");
    },
    "data-test-id": "teacher-tab"
  }, "Teacher"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab ".concat(isParent ? "active" : ""),
    onClick: function onClick() {
      teacherParentTabSwitchEvent("#parent");
    },
    "data-test-id": "parent-tab"
  }, "Parent")), /*#__PURE__*/_react["default"].createElement(_loginForm.LoginForm, {
    source: "Parent/Teacher Login",
    sendEvent: sendEvent,
    "data-sentry-element": "LoginForm",
    "data-sentry-source-file": "index.tsx"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "register-link"
  }, "New ", isParent ? "Parents" : "Teacher", "?", " ", /*#__PURE__*/_react["default"].createElement("a", {
    href: isParent ? "/parents/register" : "/teachers/register",
    onClick: function onClick() {
      return sendEvent("Register here: ".concat(isParent ? "/parents/register" : "/teachers/register"));
    }
  }, "Register here")));
};